export default "__VITE_ASSET__BwZUXWMK__"